import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Manufacturing_ds_get_material_substitutionsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { material_ids?: number[], package_id?: number, warehouse_id?: number, substitution_ids?: number[] }): 
  Promise<{ result: { Id?: number, MaterialId?: number, PackagingId?: number, Ratio?: number, SubstitutionMaterialId?: number, SubstitutionPackagingId?: number, SubstitutionMaterialPackagingLookup?: { PackagingId?: number, BasePackagingQuantity?: number, Material?: { Id?: number, Name?: string, InventoryByWarehouseMaterial?: { WarehouseId?: number, MaterialId?: number, PackagedId?: number, CurrentlyAvailableAmount?: number, CurrentlyAvailablePackagedAmount?: number }[] }, Packaging?: { Name?: string, ShortName?: string } } }[] }> 
  {
    let url = `${environment.backendUrl}api/Manufacturing/datasources/ds_get_material_substitutions/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { material_ids?: number[], package_id?: number, warehouse_id?: number, substitution_ids?: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, MaterialId?: number, PackagingId?: number, Ratio?: number, SubstitutionMaterialId?: number, SubstitutionPackagingId?: number, SubstitutionMaterialPackagingLookup?: { PackagingId?: number, BasePackagingQuantity?: number, Material?: { Id?: number, Name?: string, InventoryByWarehouseMaterial?: { WarehouseId?: number, MaterialId?: number, PackagedId?: number, CurrentlyAvailableAmount?: number, CurrentlyAvailablePackagedAmount?: number }[] }, Packaging?: { Name?: string, ShortName?: string } } }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/Manufacturing/datasources/ds_get_material_substitutions/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { material_ids?: number[], package_id?: number, warehouse_id?: number, substitution_ids?: number[], $keys: number[] }): 
  Promise<{ result: { Id?: number, MaterialId?: number, PackagingId?: number, Ratio?: number, SubstitutionMaterialId?: number, SubstitutionPackagingId?: number, SubstitutionMaterialPackagingLookup?: { PackagingId?: number, BasePackagingQuantity?: number, Material?: { Id?: number, Name?: string, InventoryByWarehouseMaterial?: { WarehouseId?: number, MaterialId?: number, PackagedId?: number, CurrentlyAvailableAmount?: number, CurrentlyAvailablePackagedAmount?: number }[] }, Packaging?: { Name?: string, ShortName?: string } } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Manufacturing/datasources/ds_get_material_substitutions/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      material_ids?: number[], package_id?: number, warehouse_id?: number, substitution_ids?: number[]    }) {
      return false;
    }
}
